import { useState } from 'react';
import { GlobalStyles } from '@asurion-core/mx-asurion-ui-react';
import './app.css';
import { Playground } from './playground';

const STORYBOOK_URL = window.location.hostname === 'localhost' ? 'http://localhost:6006' : 'storybook/index.html';

type View = 'playground' | 'storybook';

const navStyle: React.CSSProperties = {
  display: 'flex',
  gap: '1rem',
  padding: '0.75rem 1.5rem',
  borderBottom: '1px solid #e0e0e0',
  fontFamily: 'sans-serif',
  background: '#fff',
  alignItems: 'center',
};

const getLinkStyle = (isActive: boolean): React.CSSProperties => ({
  textDecoration: 'none',
  fontWeight: isActive ? 700 : 400,
  color: isActive ? '#000' : '#555',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  padding: 0,
  font: 'inherit',
  fontSize: 'inherit',
  borderBottom: isActive ? '2px solid #000' : '2px solid transparent',
  paddingBottom: 4,
});

export const App = () => {
  const [view, setView] = useState<View>('playground');

  return (
    <>
      <GlobalStyles />
      <nav style={navStyle}>
        <button type="button" style={getLinkStyle(view === 'playground')} onClick={() => setView('playground')}>
          Playground
        </button>
        <button type="button" style={getLinkStyle(view === 'storybook')} onClick={() => setView('storybook')}>
          Storybook
        </button>
      </nav>
      <main>
        {view === 'playground' && <Playground />}
        {view === 'storybook' && (
          <iframe
            src={STORYBOOK_URL}
            style={{ width: '100%', height: 'calc(100vh - 49px)', border: 'none', display: 'block' }}
            title="Storybook"
          />
        )}
      </main>
    </>
  );
};

export default App;
